/**
 * Shared navigation labels for BHYVE rail and classic Materio sidebar.
 * Keep in sync — both shells read from here.
 */
export const GYG_NAV_LABELS = {
  howToGuides: 'How to Guides',
  howToGuide: 'How to Guide',
  guestExperience: 'Guest Experience',
  disabledIngredientsDashboard: 'Disabled Ingredients Dashboard',
  disabledIngredientsReports: 'Disabled Ingredients Reports',
  rawData: 'Raw Data',
  wasteLog: 'Waste Logging'
} as const
